export default __webpack_public_path__ + "images/e70add0ab2306f4218cf99827310be6c-jazz.jpg";